import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SpeedDial, SpeedDialContentType } from '@app/call-history/models/speed-dial.models';
import { SpeedDialService } from '@app/call-history/services/speed-dial.service';
import { ContactService } from '@app/contacts/services/contact.service';
import { NameCoinComponent } from '@app/shared/components/name-coin/name-coin.component';
import { ContactByIdPipe } from '@app/shared/pipes/contact-by-id.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    ContactByIdPipe,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    NameCoinComponent,
    TranslateModule,
  ],
  selector: 'app-copy-speed-dials-dialog',
  templateUrl: './copy-speed-dials-dialog.component.html',
  styleUrls: ['./copy-speed-dials-dialog.component.scss'],
})
export class CopySpeedDialsDialogComponent {
  protected readonly ContentType = SpeedDialContentType;

  protected fromSite: string | null = null;
  protected fromDepartment: string | null = null;
  protected toSite: string | null = null;
  protected toDepartment: string | null = null;

  protected readonly sites: string[];
  protected readonly departments: string[];

  constructor(
    protected speedDialService: SpeedDialService,
    private contactService: ContactService,
    private dialogRef: MatDialogRef<CopySpeedDialsDialogComponent>
  ) {
    this.sites = this.contactService.allPBXSites;
    this.departments = this.contactService.allPBXDepartments;
  }

  protected get previewDials(): SpeedDial[] {
    return this.speedDialService.speedDials.filter(
      (d: SpeedDial) =>
        d.system &&
        (this.fromSite === null || d.site === this.fromSite) &&
        (this.fromDepartment === null || d.department === this.fromDepartment)
    );
  }

  protected async confirm(): Promise<void> {
    await this.speedDialService.copySpeedDialsFromGroup(
      this.fromSite,
      this.fromDepartment,
      this.toSite,
      this.toDepartment
    );
    this.dialogRef.close();
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
